<template>
    <div class="fixed-top">
        <div class="top-header"  v-if="!notDisplayHeader.includes(this.$route.name) && login.token">
            <div class="container">
                <nav class="navbar navbar-expand">
                    <div class="mr-3 order-2 order-md-1">
                        <router-link to="/home" class="link"><i class="sprite ic-home mr-3"></i></router-link>
                        <span class="link">{{$route.name == 'home'? "Home" :($route.name == 'past-script-details'? (eScript ? 'eScript Detail':'Script Detail') : routeName)}}</span>&nbsp;
                        
                        <!-- <span class="link" v-if="$route.name == 'chat'">{{lang.label.chat}}</span> -->

                    </div>
                    <div class="navbar-collapse justify-content-center order-1 order-md-2">
                        <router-link to="/home"><img src="../assets/styles/img/logo-small.png" alt="Pay Script" class="logo-img" /></router-link>
                    </div>
                    <div class="ml-3 order-3 order-md-3 logout">
                        <!-- temporary commented chat module-->
                        <!-- <template v-if="$route.name == 'past-request-details' || $route.name == 'group-request-details' " >
                            <a href="javascript:void(0)" :title="lang.label.chat" class="link" @click="chatModule()" v-if="groupRequestDetails.canChat!=='No'"><i style="font-size: 30px;" class="el-icon-chat-round mr-3"></i></a>
                        </template> -->
                         <!-- <template v-if="($route.name =='home') " >
                            <a href="javascript:void(0)" :title="lang.label.chat" class="link" @click="chatModule()"><i style="font-size: 30px;" class="el-icon-chat-round mr-3"></i></a>
                        </template> -->
                        <a href="javascript:void(0)" :title="lang.label.notificationStatus" class="link" @click="changeStatus(0)" v-if="notificationStatus == 1"><i style="font-size: 30px;" class="el-icon-bell mr-3"></i></a>
                        <a href="javascript:void(0)" :title="lang.label.notificationStatus" class="link" @click="changeStatus(1)" v-if="notificationStatus == 0"><i style="font-size: 30px;" class="el-icon-close-notification mr-3"></i></a>
                        <a href="javascript:void(0)" class="link" @click="logout"><i class="sprite ic-log-out mr-3"></i><span>{{lang.label.buttons.logout}}</span></a>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";
    import jsondata from "../assets/json/data.json";
    export default {
        components: {},
        data() {
            return {
                lang: this.$lang.header,
                notDisplayHeader: ["login", "register", "otp", "contact-details"],
                data: jsondata,
                routeName: '',

            };
        },
        computed: {
            ...mapGetters({
                    login: "login",
                    eScript: "eScript",
                    unauthorized: "unauthorized",
                    showAlert: "showAlert",
                    notificationStatus: "notificationStatus",
                    frompath:"frompath",
                    groupRequestDetails: "groupRequestDetails",

                    
            })
        },
        watch: {
            showAlert: function (val) {
                if (val && Object.keys(val) && Object.keys(val).length) {
                    this.$alert(val.message, '', {
                        confirmButtonText: 'OK',
                    });
                    this.$store.commit('setShowAlert', {});
                }
            },
            $route: function (val) {
                this.getRouteName();
            },
            unauthorized: function (val) {
                if (val) {
                    this.getRouteName();
                }
            },

        },
        mounted() {
            this.getRouteName();
        },
        methods: {
            getRouteName() {
                if (this.unauthorized) {
                    this.logout();
                } else {
                    this.routeName=null
                    let filter = this.data.homeLink.filter(c => {
                        return c.url == this.$route.name;
                    });
                    if (filter[0])
                        if(this.frompath=='past-request-details' && filter[0].name=='Chat'){
                            this.routeName="Past Group Requests  "+filter[0].name
                        }else if(this.frompath=='group-request-details' && filter[0].name=='Chat'){
                            this.routeName="Group Script Requests "+filter[0].name   
                        }else if(this.frompath=='home' && filter[0].name=='Chat'){
                            this.routeName=filter[0].name   
                        }
                        else{
                            this.routeName = filter[0].name;
                        }
                }
            },
            logout() {
                if (this.unauthorized) {
                    this.$store.commit('setSessionExpired', true);
                } else {
                    this.$store.commit('setSessionExpired', false);
                }
                this.$store
                        .dispatch("logout")
                        .then(res => {
                            if (res.status == 200 || res.status == 401) {
                                clearTimeout(this.timeOut);
                                this.$store.commit("setLogin", {
                                    access_token: null,
                                    expires_in: null,
                                    loginTime: null
                                });
                                localStorage.removeItem('login');
                                if (this.$route.name != 'login') {
                                    return this.$router.push({name: 'login'});
                                }
                            }
                        });
            },
            changeStatus(status) {
                let params = {
                    "status": status
                };
                this.$store
                        .dispatch("changeNotificationStatus", params)
                        .then(res => {
                            if (res.status == 200) {
                                this.$notify({
                                    message: res.data.message,
                                    timeout: 1000,
                                    type: 'success'
                                });
                                this.login.notificationStatus = status;
                                this.$store.commit("setLogin", this.login);
                            }
                        });
            },
            chatModule(){
                this.$router.push({name: 'chat'});
            }
        },
        destroyed(){}
    };
</script>


